<template>
  <d-badge
    :theme="statusClass"
    :outline="outline">
    {{ statusName }}
  </d-badge>
</template>

<script>
import ListUtils from './../../utils/ListUtils';
import orderStatuses from './../../data/order-statuses.js';
import orderStatusClasses from './../../data/order-status-classes.js';

export default {
  name: 'status-badge',
  props: [
    'status'
  ],
  computed: {
    statusName () {
      return ListUtils.getKeyLabel(orderStatuses[this.$i18n.locale], this.status);
    },
    statusClass () {
      return ListUtils.getKeyLabel(orderStatusClasses, this.status).replace(' outline', '');
    },
    outline () {
      return ListUtils.getKeyLabel(orderStatusClasses, this.status).indexOf(' outline') > -1;
    }
  }
}
</script>
